/**
 * Разделы администрирования — одно описание для бокового меню и для вкладок.
 *
 * Меню показывает шесть разделов, а страницы внутри раздела — вкладками над
 * заголовком страницы. Адреса страниц остались прежними: прямые ссылки,
 * закладки и адреса из писем продолжают работать, права проверяет всё тот же
 * `RequireAdmin`.
 *
 * Раньше в меню было одиннадцать пунктов вперемешку: контент, люди, продажи и
 * настройки платформы стояли одним списком.
 */

export type AdminSectionPage = { label: string; to: string };
export type AdminSection = { label: string; pages: AdminSectionPage[] };

export const ADMIN_SECTIONS: AdminSection[] = [
  {
    label: 'Контент',
    pages: [
      { label: 'Игры', to: '/admin/games' },
      { label: 'МАК-сессии', to: '/admin/spreads' },
      { label: 'Колоды', to: '/admin/decks' },
      { label: 'Обучение', to: '/admin/training' },
    ],
  },
  { label: 'Пользователи', pages: [{ label: 'Пользователи', to: '/admin/users' }] },
  {
    label: 'Продажи',
    pages: [
      { label: 'Заказы', to: '/admin/orders' },
      { label: 'Тарифы и оплата', to: '/admin/products' },
      { label: 'Автопродления', to: '/admin/subscriptions' },
    ],
  },
  { label: 'Аналитика', pages: [{ label: 'Аналитика', to: '/admin/analytics' }] },
  { label: 'История сессий', pages: [{ label: 'История сессий', to: '/admin/sessions' }] },
  {
    label: 'Настройки',
    pages: [
      { label: 'Регистрация', to: '/admin/registration' },
      { label: 'Персональные данные', to: '/admin/privacy' },
    ],
  },
];

/**
 * Адрес внутри страницы вместе с её вложенными адресами: редактор колоды
 * `/admin/decks/…` относится к «Колодам». Сравнение по границе сегмента, а не
 * по началу строки — иначе `/admin/spreads` поймал бы и `/admin/spreadsheet`.
 */
export function isPathWithin(pathname: string, to: string): boolean {
  return pathname === to || pathname.startsWith(`${to}/`);
}

/** Раздел и страница, к которым относится адрес; `null` — адрес не из администрирования. */
export function adminPageOf(pathname: string): { section: AdminSection; page: AdminSectionPage } | null {
  for (const section of ADMIN_SECTIONS) {
    const page = section.pages.find((item) => isPathWithin(pathname, item.to));
    if (page) return { section, page };
  }
  return null;
}
